class InsuredEvent {
}

class Insured {
}

export { InsuredEvent as I, Insured as a };
